var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { delay } from '@loop/itops-util-basic';
export class HttpError extends Error {
    constructor(status, statusText, detail) {
        super(statusText);
        this.status = status;
        this.detail = detail;
    }
}
export class TimeoutError extends Error {
    constructor(ms) {
        super(`Request timed out after: ${ms}ms`);
        this.ms = ms;
    }
}
const fetchWithTimeout = (url, _a) => {
    var { timeout = 30000 } = _a, args = __rest(_a, ["timeout"]);
    return new Promise((resolve, reject) => {
        const timeoutHandle = setTimeout(() => reject(new TimeoutError(timeout)), timeout);
        fetch(url, args)
            .then((r) => {
            resolve(r);
            clearTimeout(timeoutHandle);
        })
            .catch((e) => {
            reject(e);
            clearTimeout(timeoutHandle);
        });
    });
};
export const fetchWithRetry = (url, _a) => __awaiter(void 0, void 0, void 0, function* () {
    var { timeout = 30000, retry = 3 } = _a, args = __rest(_a, ["timeout", "retry"]);
    let result;
    let error;
    let attempt = 1;
    while (!result && attempt <= retry) {
        error = undefined;
        attempt = attempt + 1;
        try {
            const fetched = yield fetchWithTimeout(url, Object.assign({ timeout }, args));
            if (fetched.status !== 200) {
                throw new HttpError(fetched.status, fetched.statusText, yield fetched.text());
            }
            result = fetched;
        }
        catch (e) {
            error = e;
            if (attempt <= retry && !(e instanceof TimeoutError)) {
                yield delay(timeout);
            }
        }
    }
    if (!result) {
        throw error;
    }
    return result;
});
const doError = (result) => {
    if (result.error) {
        throw new Error(result.error);
    }
    throw new Error(`Something went wrong at our end. Please try again. Received response: ${JSON.stringify(result, null, 2)}`);
};
export const jsonPostHelper = (what, { accessToken, data, retry }) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = { 'Content-Type': 'application/json' };
    if (accessToken) {
        headers['Authorization'] = accessToken;
    }
    const response = yield (retry ? fetchWithRetry : fetchWithTimeout)(what, {
        headers,
        method: 'POST',
        body: data ? JSON.stringify(data) : undefined,
    });
    const result = yield response.json();
    return result;
});
export const validatedJsonPostHelper = (what, params) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield jsonPostHelper(what, params);
    return params.validate(res);
});
//# sourceMappingURL=fetch.js.map